var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-12 pb-2",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('CharityFAQForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }